import React from 'react'
import Badge from '../../components/Badge'
export default () => (
  <Badge />
)